import React from 'react'
import axios from 'axios'
import {find} from 'lodash'
import {
  StripeProvider, Elements, injectStripe,
  CardNumberElement, CardExpiryElement, CardCVCElement, PostalCodeElement
} from 'react-stripe-elements'

import './style.css'

class StripeEl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.getAddress = this.getAddress.bind(this)
  }

  render() {
    var complete = this.state.valid && !this.state.focused
    var color = this.props.theme === 'dark' && complete ? '#fff' : '#000'

    return (
      <div className={
        'stripe-input' + ( this.state.valid ? ' ticked site-color-before' : '' )
        + (complete ? ' complete' : '')
      }>
        <div className="title">{ this.props.title }</div>
        <this.props.El
          style={ this.props.style || { base: { fontSize: '12px', color: color } } }
          onChange={ o => this.onChange(o) }
          onFocus={ _ => this.setState({ ...this.state, focused: true }) }
          onBlur={ _ => this.onBlur() }
          placeholder={ this.props.title || '' }
          elementRef={ el => { this.inputEl = el } } />
      </div>
    )
  }

  onChange(o) {
   if (this.state.valid !== o.complete)
      this.setState({...this.state, valid: o.complete })

    this.props.done(o.complete, o)
    if (this.inputEl['_componentName'] === 'postalCode'){
      if (o.value.length > 3)
        this.getAddress(o.value)
    }
  }

  onBlur(){
    this.setState({ ...this.state, focused: false })
    if (this.inputEl['_componentName'] === 'postalCode'){
      this.state.city && this.setValue(document.querySelector('input[name="address_city"]'),  this.state.city)
      this.state.country && this.setValue(document.querySelector('input[name="address_country"]'), this.state.country)
      this.state.state && this.setValue(document.querySelector('input[name="address_state"]'),this.state.state)
    }
  }

  setValue(element, value) {
    element.parentElement.classList.add(...['complete', 'ticked', 'site-color-before'])
    element.value = value || ''
  }


  getAddress(value){
    axios.get(`https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${value}&key=AIzaSyCjULGl-zqfHzWOrRwHpanj3q7uXHM4OPY`)
    .then( response =>{
      if(response.data.results.length > 0){
        const results = response.data.results[0]
        this.setState({
          country: (find(results['address_components'], (item)=>{return item.types.includes('country')}))['short_name'],
          state: (find(results['address_components'], (item) => { return item.types.includes('administrative_area_level_1') }))['short_name'],
          city: (find(results['address_components'], (item) => { 
            return item.types.includes('locality') || item.types.includes('postal_town') 
          }))['short_name']
        })
      }
    })  
    
  }
}

class InputEl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  
  render() {
    var ticked = this.state.valid
    var complete = !this.state.focused && this.state.valid
    

    return (
      <div className={
        'our-input'
        + (complete ? ' complete' : '')
        + (ticked ? ' ticked site-color-before' : '')
      }>
        <div className="title">{ this.props.title }</div>
        <input
          type="text"
          ref={ el => { this.el = el; this.props.elementRef(el) } }
          onChange={ e => this.onChange(e) }
          onFocus={ _ => this.setState({...this.state, focused: true }) }
          onBlur={ _ => this.setState({...this.state, focused: false }) }
          placeholder={ this.props.title } 
          name={this.props.name}/>
      </div>
    )
  }

  onChange(o) {
    var valid = !!this.el.value
    if (this.state.valid !== valid)
      this.setState({...this.state, valid: valid})

    this.props.done(valid)
  }
}

class StripeForm extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.formRef)
      this.props.formRef(this)
    this.state = { isReady: false }
  }

  render() {
    if (this.props.layout === 'row')
      return (
        <div className={ `cc-form ${this.props.theme} row-layout`}>
          { this.ccForm() }
          { this.addressForm() }
        </div>
      )

    //
    if (this.props.layout === 'FITNESS'){
      return (
        <div className={ `cc-form`}>
          <h3>Enter your billing details below:</h3>
          { this.addressForm() }
          <h3>Payment Information</h3>
          { this.ccForm() }
        </div>
      )
    }

   return (
      <div className={ `cc-form ${this.props.theme}`}>
        <div className="left-form">
          <div className="title"> Billing Address</div>
          { this.addressForm() }
        </div>
        <div className="right-form">
          <div className="title"> Card Details</div>
          { this.ccForm() }
        </div>
      </div>
    )
  }

  addressForm() {
    return(
      <div>
        <InputEl
          title="Name on card"
          done={ d => this.setReady('name', d) }
          elementRef={ el => { this.nameInput = el } } />
        <InputEl
          title="Street Address"
          done={ d => this.setReady('address', d) }
          elementRef={ el => { this.addressInput = el } } />
        <div className="zip-city">
          <StripeEl
            theme={ this.props.theme }
            El={PostalCodeElement}
            style={ this.props.stripeElStyle }
            done={ d => { this.setReady('zip', d) } }
            title="ZIP Code" />
          <InputEl
              title="City"
              done={d => { this.setReady(null,d) }}
              elementRef={el => { this.cityInput = el }}
              name="address_city" />
        </div>
      
        <div className="state-country">
          <InputEl
            title="State"
            done={d => { this.setReady(null,d) }}
            elementRef={el => { this.stateInput = el }} 
            name="address_state"/>
          
          <InputEl
            title="Country"
            elementRef={el => { this.countryInput = el }}
            done={d => { this.setReady(null,d) }}
            name="address_country" />
        </div>
        {this.props.leftContent}
      </div>  
    )    
  }

  ccForm() {
    return (
      <div>
        <StripeEl
          theme={ this.props.theme }
          style={ this.props.stripeElStyle }
          El={CardNumberElement}
          title="Card Number"
          done={ d => this.setReady('number', d) } />
        <div className="exp-cvc">
          <StripeEl
            theme={ this.props.theme }
            El={CardExpiryElement}
            style={ this.props.stripeElStyle }
            title="Expiration MM/YY"
            done={ d => this.setReady('expiry', d) } />
          <StripeEl
            theme={ this.props.theme }
            style={ this.props.stripeElStyle }
            El={CardCVCElement}
            title="CVC"
            done={ d => this.setReady('cvc', d) } />
        </div>
        { this.props.rightContent }
      </div>
    )
  }

  setReady(field, ready) {
    var readySet = this.readySet = this.readySet || new Set()
    if(field !== null){
      if (ready) readySet.add(field)
      else readySet.delete(field)
    }

    var isReady = (readySet.size === 6) && (this.cityInput.value !== '' && this.stateInput.value !== '' && this.countryInput.value !== '' && this.nameInput.value !== '' )
    if (isReady !== this.state.isReady) {
      if (this.props.onReady)
        this.props.onReady(isReady)
      this.setState({...this.state, isReady: isReady })
    }
  }

  createToken() {
    return this.props.stripe.createToken({
      name: this.nameInput.value,
      address_line1: this.addressInput.value,
      address_city: this.cityInput.value,
      address_state: this.stateInput.value,
      address_country: this.countryInput.value
    }).then(o => {
      if (o.error)
        throw new Error(o.error.message || 'Error!')
      return o.token
    })
  }
}

var IStripeForm = injectStripe(StripeForm)

class StripeCCForm extends React.Component {
  render() {
    return (
      <StripeProvider apiKey={ this.props.apiKey }>
        <Elements
          fonts={this.props.fonts || []}
        >
          <IStripeForm
            theme={ this.props.theme || 'dark' }
            layout={ this.props.layout }
            formRef={ el => this.props.formRef(el) }
            stripeElStyle={ this.props.stripeElStyle }
            onReady={ this.props.onReady }
            leftContent={ this.props.leftContent }
            rightContent={ this.props.rightContent }
            />
        </Elements>
      </StripeProvider>
    )
  }
}

export default StripeCCForm